import { Box, Chip, Typography } from '@mui/material'
import { MRT_ColumnDef } from 'material-react-table'

import { numberWithCommasPlaces } from '../../../../base/components/MyInputs/NumberInput'
import { MonedaProps } from '../../../../interfaces/monedaPrecio.ts'

/**
 * Columnas para el listado de mis monedas
 * @param moneda
 * @constructor
 */
export const MonedaFieldsColumns = (
  moneda: MonedaProps,
): MRT_ColumnDef<MonedaProps>[] => [
  {
    accessorKey: 'codigo',
    header: 'Código',
    footer: 'Código',
    size: 100,
  },
  {
    accessorKey: 'sigla',
    header: 'Sigla',
    footer: 'Sigla',
    size: 140,
  },
  {
    accessorKey: 'descripcion',
    header: 'Descripción',
    footer: 'Descripción',
  },
  {
    accessorKey: 'tipoCambio',
    header: 'Tipo de Cambio',
    footer: 'Tipo de Cambio',
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    muiTableBodyCellProps: {
      align: 'right',
    },
    Cell: ({ row }) => (
      <Box>
        <Typography variant="subtitle2" display={'inline'}>
          {numberWithCommasPlaces(row.original.tipoCambio)}
        </Typography>
        <Typography variant="caption" display={'inline'} sx={{ ml: 1 }}>
          {moneda?.sigla || ''}
        </Typography>
      </Box>
    ),
  },
  {
    accessorKey: 'tipoCambioCompra',
    header: 'T. C. Compra',
    footer: 'T. C. Compra',
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    muiTableBodyCellProps: {
      align: 'right',
    },
    Cell: ({ row }) => (
      <Box>
        {row.original.tipoCambioCompra ? (
          <>
            <Typography variant="subtitle2" display={'inline'}>
              {numberWithCommasPlaces(row.original.tipoCambioCompra)}
            </Typography>
            <Typography variant="caption" display={'inline'} sx={{ ml: 1 }}>
              {moneda?.sigla || ''}
            </Typography>
          </>
        ) : (
          '--'
        )}
      </Box>
    ),
  },
  {
    accessorKey: 'state',
    header: 'Estado',
    footer: 'Estado',
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    muiTableBodyCellProps: {
      align: 'center',
    },
    Cell: ({ row }) => (
      <Chip label={row.original.state || 'ELABORADO'} size={'small'} color={'info'} />
    ),
  },
]
